import { Component } from 'react';

// Class component — React's error boundaries require class API.
// Catches render/lifecycle errors in children and shows a fallback UI.
// Mount one at the AppShell level and one per Route for graceful degradation.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.handleReload = this.handleReload.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  handleReload() {
    if (typeof window !== 'undefined') window.location.reload();
  }

  handleReset() {
    this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    if (typeof this.props.fallback === 'function') {
      return this.props.fallback({ error, reset: this.handleReset });
    }

    return (
      <div
        className="lk-page"
        role="alert"
        style={{
          display: 'grid',
          placeItems: 'center',
          minHeight: '60vh',
          gap: '12px',
          padding: 24,
          textAlign: 'center',
        }}
      >
        <h2 style={{ margin: 0 }}>Что-то пошло не так</h2>
        <p className="lk-text-muted" style={{ margin: 0, maxWidth: 520 }}>
          {error?.message || 'Неожиданная ошибка рендера.'}
        </p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button
            type="button"
            className="lk-btn"
            onClick={this.handleReset}
          >
            Попробовать снова
          </button>
          <button
            type="button"
            className="lk-btn lk-btn--primary"
            onClick={this.handleReload}
          >
            Перезагрузить страницу
          </button>
        </div>
      </div>
    );
  }
}
